"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var store_1 = require("../store/store");
var listViewBitFlagsUtil_1 = require("owa-bit-flags/lib/utils/listViewBitFlagsUtil");
var owa_options_core_1 = require("owa-options-core");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    viewStateConfiguration: function () { return owa_session_store_1.getUserConfiguration().ViewStateConfiguration; },
})(legacy_1.action('saveDateHeadersOption')(function saveDateHeadersOption(isEnabled, state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, viewStateConfiguration, isDateHeadersEnabled;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, viewStateConfiguration = state.viewStateConfiguration;
                    isDateHeadersEnabled = isEnabled === void 0 ? optionState.isEnabled : isEnabled;
                    listViewBitFlagsUtil_1.setBit(!isDateHeadersEnabled, 2 /* DateHeadersDisabled */);
                    return [4 /*yield*/, owa_options_core_1.updateUserConfiguration([
                            {
                                propertyName: 'ListViewBitFlags',
                                propertyType: 'Integer32',
                                propertyValue: "" + viewStateConfiguration.ListViewBitFlags,
                            },
                        ], 'OWA.ViewStateConfiguration')];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveDateHeadersOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-date-headers-option/lib/actions/saveDateHeadersOption.js
// module id = 5084
// module chunks = 2